import { useUsersServiceUsersInviteCreate } from '@organization/api/queries'
import { useFormWizard } from '@organization/features/users/context'
import { useValidationsFields } from '@organization/features/users/hooks'
import { paths } from '@organization/router'
import { inviteUrl } from '@organization/utils'
import { useSessionContext } from '@shared/hooks'
import { showApiErrors } from '@shared/utils'
import { App, Button, Card, Flex, Form, Input } from 'antd'
import { UserAdd } from 'iconsax-react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export const InviteUserForm = () => {
  const [form] = Form.useForm()

  const { t } = useTranslation()
  const { notification } = App.useApp()
  const { user } = useSessionContext()
  const { nextStep } = useFormWizard()
  const { required, personalCode } = useValidationsFields()

  const navigate = useNavigate()

  const { mutate: inviteUser, isPending: isInvitePending } =
    useUsersServiceUsersInviteCreate({
      onSuccess: (data) => {
        if (Array.isArray(data) && data.length > 0 && data[0]?.id) {
          nextStep([data[0].id])
          notification.success({ message: t('users.email_sent') })
        } else {
          const fallbackEmail = data?.[0]?.user?.email ?? t('users.unknown')
          showApiErrors(t('error.already_invited', { item: fallbackEmail }))
        }
      },
      onError: (error) => showApiErrors(error, form)
    })

  const onSubmit = async () => {
    const values = await form.validateFields()

    inviteUser({
      requestBody: {
        organization_id: Number(user?.organization?.id),
        users: [
          {
            email: values.email,
            identification_number: values.identification_number
          }
        ],
        invite_url: inviteUrl
      }
    })
  }

  return (
    <Card
      title={t('table.email')}
      actions={[
        <Flex key={1} justify="end" gap={8}>
          <Button danger onClick={() => navigate(paths.users.root)}>
            {t('button.cancel')}
          </Button>
          <Button
            form="inviteUserForm"
            type="primary"
            htmlType="submit"
            loading={isInvitePending}
            icon={<UserAdd size={14} />}
          >
            {t('button.users_invite')}
          </Button>
        </Flex>
      ]}
    >
      <Form id="inviteUserForm" form={form} onFinish={onSubmit}>
        <Form.Item
          name="email"
          rules={[
            {
              required: true,
              message: t('form.message.email_required')
            },
            {
              type: 'email',
              message: t('form.message.invalid_email')
            }
          ]}
        >
          <Input
            name="email"
            type="email"
            placeholder={t('form.placeholder.email')}
          />
        </Form.Item>

        <Form.Item
          name="identification_number"
          normalize={(value, prevValue) =>
            String(value).length > 13 ? prevValue : value
          }
          rules={[required, personalCode]}
        >
          <Input placeholder={t('identification_number')} />
        </Form.Item>
      </Form>
    </Card>
  )
}
